import { useContext as t } from "react";
import { FormContext as s } from "../FormContext.js";
const a = ({
  component: o,
  defaultValue: e,
  message: r
}) => {
  if (t(s) && e !== void 0)
    throw new Error(
      r ?? `Using the defaultValue prop on an ${o} inside an IressForm component is not supported. Please use the defaultValue prop on the IressFormField, or use defaultValues on the IressForm component (recommended) to ensure a single source of truth for your form.`
    );
};
export {
  a as useNoDefaultValueInForms
};
